export default "__VITE_ASSET__CjtR5Q16__"